import classNames from "classnames";
import SVGBullet from "../../icons/Bullet.svg?react";
import { Glyph } from "../../types";
import styles from "./Bullet.module.css";

export const SVGBulletAccounting: Glyph = (props) => (
  <SVGBullet
    {...props}
    className={classNames(props.className, styles.accounting)}
  />
);

export const SVGBulletJoinHospitality: Glyph = (props) => (
  <SVGBullet
    {...props}
    className={classNames(props.className, styles.joinHospitality)}
  />
);

export const SVGBulletPayroll: Glyph = (props) => (
  <SVGBullet
    {...props}
    className={classNames(props.className, styles.payroll)}
  />
);

export const SVGBulletWebMarketing: Glyph = (props) => (
  <SVGBullet
    {...props}
    className={classNames(props.className, styles.webMarketing)}
  />
);

export default SVGBullet;
